import { Component, OnInit } from '@angular/core';
import { UserService } from '../app-services/user.service';
import { AuthService } from '../app-services/auth.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.css']
})
export class OnboardingComponent implements OnInit {

  constructor(private userService: UserService,
    private authService: AuthService,
    public snackBar: MatSnackBar) { }

    isLoggedIn$;

  userOnboarding = {
    user: {
      name: '',
      dob: '',
      currency: '',
      country: '',
      level: '',
      onboarding: 0
    },
    entrieDetails: {
      networth: 0,
      budget: 0
    },
    goalDetails: {
      goalsCount: 0,
      linkedGoalEntriesCount: 0
    }
  };

  percentageComplete = 0;
  currentQuestion = 0;
  lastAnswered = 0;

  countryList = ['afghanistan', 'albania', 'algeria', 'andorra', 'angola', 'anguilla',
    'antigua &amp; barbuda', 'argentina', 'armenia', 'aruba', 'australia', 'austria', 'azerbaijan', 'bahamas',
    'bahrain', 'bangladesh', 'barbados', 'belarus', 'belgium', 'belize', 'benin', 'bermuda', 'bhutan',
    'bolivia', 'bosnia &amp; herzegovina', 'botswana', 'brazil', 'british virgin islands',
    'brunei', 'bulgaria', 'burkina faso', 'burundi', 'cambodia', 'cameroon', 'canada', 'cape verde',
    'cayman islands', 'chad', 'chile', 'china', 'colombia', 'congo', 'cook islands', 'costa rica',
    'cote d ivoire', 'croatia', 'cruise ship', 'cuba', 'cyprus', 'czech republic', 'denmark', 'djibouti',
    'dominica', 'dominican republic', 'ecuador', 'egypt', 'el salvador', 'equatorial guinea',
    'estonia', 'ethiopia', 'falkland islands', 'faroe islands', 'fiji', 'finland', 'france', 'french polynesia',
    'french west indies', 'gabon', 'gambia', 'georgia', 'germany', 'ghana',
    'gibraltar', 'greece', 'greenland', 'grenada', 'guam', 'guatemala', 'guernsey', 'guinea', 'guinea bissau',
    'guyana', 'haiti', 'honduras', 'hong kong', 'hungary', 'iceland', 'india',
    'indonesia', 'iran', 'iraq', 'ireland', 'isle of man', 'israel', 'italy', 'jamaica', 'japan', 'jersey',
    'jordan', 'kazakhstan', 'kenya', 'kuwait', 'kyrgyz republic', 'laos', 'latvia',
    'lebanon', 'lesotho', 'liberia', 'libya', 'liechtenstein', 'lithuania', 'luxembourg', 'macau', 'macedonia',
    'madagascar', 'malawi', 'malaysia', 'maldives', 'mali', 'malta', 'mauritania',
    'mauritius', 'mexico', 'moldova', 'monaco', 'mongolia', 'montenegro', 'montserrat', 'morocco', 'mozambique',
    'namibia', 'nepal', 'netherlands', 'netherlands antilles', 'new caledonia', 'new zealand', 'nicaragua', 'niger',
    'nigeria', 'norway', 'oman', 'pakistan', 'palestine', 'panama', 'papua new guinea',
    'paraguay', 'peru', 'philippines', 'poland', 'portugal',
    'puerto rico', 'qatar', 'reunion', 'romania', 'russia', 'rwanda', 'saint pierre &amp; miquelon', 'samoa',
    'san marino', 'satellite', 'saudi arabia', 'senegal', 'serbia', 'seychelles', 'sierra leone', 'singapore',
    'slovakia', 'slovenia', 'south africa', 'south korea', 'spain', 'sri lanka',
    'st kitts &amp; nevis', 'st lucia', 'st vincent', 'st. lucia', 'sudan',
    'suriname', 'swaziland', 'sweden', 'switzerland', 'syria', 'taiwan', 'tajikistan', 'tanzania',
    'thailand', 'timor l\'este', 'togo', 'tonga', 'trinidad &amp; tobago', 'tunisia',
    'turkey', 'turkmenistan', 'turks &amp; caicos', 'uganda', 'ukraine', 'united arab emirates',
    'united kingdom', 'united states', 'united states minor outlying islands', 'uruguay',
    'uzbekistan', 'venezuela', 'vietnam', 'virgin islands (us)', 'yemen', 'zambia', 'zimbabwe'];


  ngOnInit() {
    // check if the user is logged in or not
    this.authService.isLoggedIn.subscribe( response => {
            // if the user logs in then check if the onboarding is complete or not
            if (response === true) {
              this.percentageComplete = 0;
              this.currentQuestion = 0;
              this.lastAnswered = 0;
              this.getNextUnansweredOnboardingQuestion();
            }
            this.isLoggedIn$ = response;
    });
  }


  public finishEdit(updatedUser) {

    this.userService.updateUserDetails(updatedUser).subscribe(res => {
      // show the next question if there is one
      this.getNextUnansweredOnboardingQuestion();
    });
  }

  checkLastAnswered(question) {
    this.lastAnswered = question;
  }

  getNextUnansweredOnboardingQuestion() {
    // do a user onboarding check in the backend
    this.userService.getUserOnboardingStatus().subscribe(response => {
      this.userOnboarding = response;
      let answeredQuestions = 0;
      this.currentQuestion = 0;

      // check which onboarding questions/actions are next
      if (this.userOnboarding.user.onboarding === 0) {
        this.currentQuestion = 7;
        answeredQuestions++;
      }

      if (this.userOnboarding.goalDetails.goalsCount === 0) {
        if (this.lastAnswered === 6) {
          this.snackBar.open('No goals created yet! Please create a goal!', '', {
            duration: 3000,
          });
        }
        this.currentQuestion = 6;
        answeredQuestions++;
      }

      if (this.userOnboarding.entrieDetails.budget === 0) {
        if (this.lastAnswered === 5) {
          this.snackBar.open('Please create some entries like in the example first!', '', {
            duration: 3000,
          });
        }
        this.currentQuestion = 5;
        answeredQuestions++;
      }

      if (this.userOnboarding.entrieDetails.networth === 0) {
        if (this.lastAnswered === 4) {
          this.snackBar.open('Please create some entries like in the example first!', '', {
            duration: 3000,
          });
        }
        this.currentQuestion = 4;
        answeredQuestions++;
      }

      if (this.userOnboarding.user.dob === null) {
        this.currentQuestion = 3;
        answeredQuestions++;
      }

      if (this.userOnboarding.user.country === null) {
        this.currentQuestion = 2;
        answeredQuestions++;
      }

      if (this.userOnboarding.user.name === null) {
        this.currentQuestion = 1;
        answeredQuestions++;
      }

      // if (this.userOnboarding.user.currency === null) {
      //   this.currentQuestion = 1;
      //   answeredQuestions++;
      // }
      this.percentageComplete = Math.round(((answeredQuestions / 7) - 1) * -100);
    });
  }

  finishOnboarding() {
    this.userOnboarding.user.onboarding = 1;
    this.userService.updateUserDetails(this.userOnboarding.user).subscribe(res => {
      // show the next question if there is one
      this.getNextUnansweredOnboardingQuestion();
    });
  }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/onboarding/onboarding.component.ts